import fetch from '@/fetch'

const transformFilter = filter => {
  const handleArray = (key, values) => {
    return values.map(v => `${key}=${v}`)
  }

  return Object.entries(filter)
    .filter(([, value]) => !!value)
    .map(([key, value]) => {
      if (Array.isArray(value)) return handleArray(key, value).join('&')
      return { [key]: value }
    })
    .filter(Boolean)
    .map(v => new URLSearchParams(v))
    .join('&')
}

export default {
  getData(options = {}) {
    const { id, preset, context = 'project' } = options
    return fetch(`/api/analytics/${id}/presets/${preset}?context=${context}`, {
      method: 'get',
    }).then(res => res.json())
  },
  getDashboardWidget(options = {}) {
    const { id, preset, filter } = options

    return fetch(`/api/analytics/${id}/dashboard/${preset}${filter ? `?${transformFilter(filter)}` : ''} `, {
      method: 'get',
    }).then(res => res.json())
  },
}
